import CryptoJS from 'crypto-js';
import { toast } from "react-toastify";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

function normalizePlate(plate) {
  return typeof plate === "string" ? plate.trim() : "";
}

function readStoredPayload() {
  const encryptedPayload = localStorage.getItem('data');

  if (!encryptedPayload) {
    return [];
  }

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedPayload, SECRET_KEY);
    const decryptedPayload = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedPayload);
  } catch (error) {
    console.error('Failed to decrypt payload:', error);
    return [];
  }
}

function writeStoredPayload(payload) {
  const payloadString = JSON.stringify(payload);
  const newEncryptedPayload = CryptoJS.AES.encrypt(payloadString, SECRET_KEY).toString();
  localStorage.setItem('data', newEncryptedPayload);
}

function savePayload(payload) {
  const existingArray = readStoredPayload();
  const plate = normalizePlate(payload?.plate);

  if (!plate) {
    toast.error('پلاک برای ثبت موقت الزامی است');
    return;
  }

  const existingIndex = existingArray.findIndex(
    (item) => normalizePlate(item?.plate) === plate
  );

  if (existingIndex === -1) {
    existingArray.push(payload);
  } else {
    const previousPayload = existingArray[existingIndex];
    existingArray[existingIndex] = {
      ...previousPayload,
      ...payload,
      plate,
      image: payload?.image?.length ? payload.image : (previousPayload?.image || []),
      weight_empty: payload?.weight_empty ?? previousPayload?.weight_empty ?? null,
      weight_fill: payload?.weight_fill ?? previousPayload?.weight_fill ?? null,
      machine: payload?.machine ?? previousPayload?.machine ?? null,
      driver: payload?.driver ?? previousPayload?.driver ?? null,
      origins: payload?.origins ?? previousPayload?.origins ?? null,
      destinations: payload?.destinations ?? previousPayload?.destinations ?? null,
      jens: payload?.jens ?? previousPayload?.jens ?? null,
      jens_code: payload?.jens_code ?? previousPayload?.jens_code ?? null,
    };
  }

  try {
    writeStoredPayload(existingArray);
    toast.success('با موفقیت ذخیره شد');
  } catch (error) {
    console.error('Failed to save new payload:', error);
  }
}

function getMatchingPlates(allField) {
  const payload = loadPayload();
  const plate = normalizePlate(allField);

  if (!payload.length || !plate) {
    return [];
  }

  return payload.filter(
    (item) => normalizePlate(item?.plate) === plate
  );
}

function loadPayload() {
  return readStoredPayload();
}

function deleteRecordByCode(pelak) {
  const payload = loadPayload();
  const normalizedPelak = normalizePlate(pelak);

  if (!payload.length || !normalizedPelak) {
    return;
  }

  const updatedPayload = payload.filter(
    (item) => normalizePlate(item?.plate) !== normalizedPelak
  );

  try {
    writeStoredPayload(updatedPayload);
  } catch (error) {
    console.error('Failed to save updated payload:', error);
  }
}

export { savePayload, loadPayload, getMatchingPlates, deleteRecordByCode };
